import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../data-access/error/error/error-handler.service';

/** Set on a request whose failure the caller handles itself, so no error modal is shown. */
export const SILENT_HTTP_ERRORS = new HttpContextToken<boolean>(() => false);

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
	constructor(private errorHandler: ErrorHandlerService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				// Dejar que el interceptor de refresh maneje 401
				if (error.status === 401 || request.context.get(SILENT_HTTP_ERRORS)) {
					return throwError(() => error);
				}
				this.errorHandler.handleError(error);
				return throwError(() => error);
			})
		);
	}
}
